import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Icon from '../../../components/icons';
import { useNavigate } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import partsImg from '../../../images/parts-pic.jpg';
import Drawer from '../../../components/Drawer';
import CreateStockadjustment from './_components/createStockadjustment';
import Button from '../../../components/elements/button';
import { Dropdown, Menu } from '../../../components/Dropdown';
import { useStockAdjustmentApi } from '../../../store/api/hooks/stockAdjustmentApiHook';
import { PAGE_SIZE } from '../../../_common/constant';
import { downloadExcel, downloadPDF, showDate } from '../../../_common/functions';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import { filterConfigType } from '../../../_config/types';
import Filters from '../../../components/filters';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import { useFacilityManagersSelector } from '../../../store/selectors/masterSelector';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';


const StockAdjustment: React.FC = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const stockAPI = useStockAdjustmentApi();
    const facilityApi: any = useFacilitiesApi();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const commonApi: any = useCommonApi();

    const users = useFacilityManagersSelector();

    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const filterConfig: filterConfigType[] = [
        { name: 'Code', type: 'text', key: 'stockAdjustmentSerialNo' },
        { name: 'Operator', type: 'dropdown', key: 'operatorIDs', options: users ? users : [] },

       
    ]

    useEffect(() => {
        if (users == null) {
            commonApi.GetUserList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [users])

    const [facilityoption, setFacilityoption] = useState<any>([]);

    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [rowData, setRowData] = useState<any>(null)
    const [editData, setEditData] = useState<any>(null);
    const { confirm } = useDialog();
    const stockRef: any = React.createRef<HTMLButtonElement>();

    const handleClose = () => setIsOpen(false);

    const getStockAdjustmentList = () => {

        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        stockAPI.getStockAdjustmentList(payload, (data: any) => {
            setTotalRecords(data.totalRecord);
            setRowData(data.stockAdjustmentList ? data.stockAdjustmentList : []);
        }, (error: any) => {
            setRowData([]);
        });
    };
    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                // Implement edit action
                setEditData(rowData);
                stockRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Stock Adjustment',
                    message: 'Are you sure you want to delete this Stock Adjustment?',
                    onConfirm: () => {
                        stockAPI.deleteStockAdjustment({ StockAdjustmentID: rowData.partsStockAdjustmentID }, (data: any, msg: any) => {
                            toast.success(msg);
                            getStockAdjustmentList();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;

            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facility: any) => {
                    facilitylist.push({
                        label: facility.facilityName,
                        value: facility.facilityID,
                        data: facility
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    /* const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const assetIDs = selectedData.map((asset: any) => asset.assetID).join(',');
            const payload = { assetIDs: assetIDs };
            stockAPI.Exportpdf(
                payload,
                (resp: any) => {
                    downloadPDF(resp, 'assets')
                },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    }; */

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const IDs = selectedData.map((rowData: any) => rowData.partsStockAdjustmentID).join(',');
            const payload = { partsStockAdjustmentID: IDs };
            stockAPI.Exportcsv(
                payload,
                (resp: any) => { downloadExcel(resp, 'StockAdjustment') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };



    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Adjustment No', field: 'stockAdjustmentSerialNo', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150 },
        {
            headerName: 'Adjustment Date', field: 'stockAdjustmentDate', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150,
            cellRenderer: (data: any) => showDate(data.value)
        },
        { headerName: 'Adjusted By ', field: 'addedByName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150 },
        { headerName: 'Number of Parts', field: 'adjustedQuantity', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150 },
        { headerName: 'Reason for adjustment', field: 'stockAdjustmentNote', headerClass: 'bg-[#f0f0f0]', minWidth: 200 },
        { headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150 },
        { headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150 },
        // { headerName: 'Sub Facility', field: 'sub-facility', headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,

            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {

                                handleActionChange(e, params);
                                //e.target.value = '';
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit">Edit</option>
                            <option value="delete">Delete</option>
                        </select>
                    </div>
                );
            },

        }
    ];
    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };
    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    useEffect(() => {
        getStockAdjustmentList();
    }, [currentPage, searchParam, filters]);

    useEffect(() => {
        getfacilitylist();
    }, []);

    return (
        <Layout>
            <Header title='Stock Adjustment'>
                <Header.Right>
                    <Drawer _ref={stockRef} onClose={() => setEditData(null)} outsideClose={false}>
                        <Drawer.Button>
                            <Button>New Stock Adjustment</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Stock Adjustment' : 'New Stock Adjustment'} className='!w-[45rem]'>
                            <CreateStockadjustment editID={editData?.partsStockAdjustmentID} onCreate={() => {
                                setEditData(null);
                                getStockAdjustmentList();
                                stockRef.current.close();
                            }} onCancel={() => {
                                setEditData(null);
                                stockRef.current.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            {/* <Menu onClick={onBulkExportPdf}>Export pdf</Menu> */}

                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div>
                <div className='flex items-center justify-between px-3 border-b border-gray-200 h-[3.75rem]'>
                    <Pagination
                        perPage={PAGE_SIZE}
                        totalRecords={totalRecords}
                        onPageChange={setCurrentPage}
                        currentPage={currentPage}
                    />
                    <Search onSearch={setSearchParam} />
                </div>
                <div className='bg-[#FAFAFA]'>
                    <div className='flex gap-4 px-5 py-2 items-center'>
                        <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} /></Button>
                        <Dropdown>
                            <Dropdown.Button>
                                <Button theme='light'><Icon name='grlocation' size={1.20} /> Location <Icon name='arrowdown' size={1.10} /></Button>
                            </Dropdown.Button>
                            <Dropdown.Content >
                                {facilityoption?.map((facility: any) => {
                                    return (
                                        <Menu onClick={() => {
                                            console.log('facility', facility);
                                            setFilters({ ...filters, facilityIDs: [facility.value] })
                                        }}>{facility.label}</Menu>
                                    )
                                }
                                )}
                            </Dropdown.Content>
                        </Dropdown>
                        <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => { setFilters({}) }} >Clear Filters</p>
                    </div>
                    <div className="ag-theme-alpine mx-4  h-1/2">
                        <AgGridReact
                            columnDefs={columnDefs} // Pass columnDefs
                            rowData={rowData} // Pass rowData
                            rowSelection="multiple"
                            onGridReady={onGridReady}
                            pagination={false}
                            onRowClicked={onRowClicked}
                            domLayout="autoHeight"
                        />
                    </div>
                </div>
                {/* Add your component code here */}
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default StockAdjustment;